import type { FunctionComponent } from 'react';
import TotalScoreBar from './TotalScoreBar';
import type { TotalScore } from '../../data/Score';

export interface StateProps {
	previousScore: TotalScore;
	score: TotalScore;
	currentRoundIndex: number;
	roundCount: number;
}

export interface DispatchProps {}

export interface OwnProps {
	/**
	 * Animation delay in seconds
	 */
	animationDelay?: number;
	onSettingsClick: () => void;
}

type Props = StateProps & DispatchProps & OwnProps;

const ScoreBarMapLayer: FunctionComponent<Props> = (props: Props) => {
	const {
		previousScore,
		score,
		animationDelay = 2,
		currentRoundIndex,
		roundCount,
		onSettingsClick
	} = props;

	return (
		<TotalScoreBar
			previousScore={previousScore}
			score={score}
			animationDelay={animationDelay}
			currentRoundIndex={currentRoundIndex}
			roundCount={roundCount}
			onSettingsClick={onSettingsClick}
			position="absolute"
			right="0"
			top="0"
		/>
	);
};

export default ScoreBarMapLayer;
